import React from "react";
import { motion } from "framer-motion";
import styles from "./CircularProgressBar.module.scss";

const CircularProgressBar = ({ name, percentage }) => {
  const circleVariants = {
    initial: { strokeDasharray: "0, 100" },
    animate: { strokeDasharray: `${percentage}, 100` },
  };

  return (
    <div className={styles.main}>
      <div className={styles.container}>
        <svg className={styles.svg} viewBox="0 0 36 36">
          <circle className={styles.track} cx="18" cy="18" r="15.9155" />
          <motion.circle
            className={styles.circle}
            cx="18"
            cy="18"
            r="15.9155"
            variants={circleVariants}
            initial="initial"
            animate="animate"
            transition={{ duration: 1, ease: "easeOut" }}
          />
        </svg>
        <div className={styles.text}>{percentage}%</div>
      </div>
      <h3>{name}</h3>
    </div>
  );
};

export default CircularProgressBar;
